export default {
  title: {
    en: 'Rate your latest scent',
  },
  text: {
    en: 'Tell us what you thought of this fragrance!',
  },
  remindLater: {
    en: 'Remind me later',
  },
}
